/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z } from '../zod';

export const AuthGetChangePassword = {
  id: 'authentication.change-password.get',
  tag: 'Authentication',
  summary: 'Change password',
  description: 'Change users password',
  method: 'get',
  route: () => `/authentication/change-password`,
  request: {
    query: z.strictObject({ token: z.string() }),
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.object({}).optional(),
        },
      },
    },
  },
} as const satisfies Endpoint;
